var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.807 5.68678C20.1051 5.9324 20.3533 6.23701 20.5337 6.58381C20.5908 6.69354 20.548 6.82641 20.4428 6.89151L14.1769 10.7704C12.833 11.6024 11.1385 11.6198 9.77778 10.8158L3.46995 7.0884C3.36804 7.02818 3.32126 6.90422 3.36719 6.79512C3.5498 6.36134 3.83438 5.98308 4.1904 5.68904L4.19006 5.68606L4.20233 5.67924C4.46577 5.46401 4.76781 5.29465 5.09621 5.18264L9.20609 2.89938C10.9427 1.93458 13.0544 1.93458 14.791 2.89938L18.896 5.17996C19.2302 5.29285 19.5372 5.46506 19.8043 5.68454L19.807 5.68678Z",
    fill: "#FFD646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98891 8.95421C3.00709 8.77397 3.20609 8.67479 3.36206 8.76695L9.01468 12.1071C10.8557 13.195 13.1482 13.1714 14.9664 12.0458L20.611 8.55158C20.7662 8.45548 20.9686 8.55283 20.9882 8.73435C21.2683 11.3218 21.2145 13.9363 20.827 16.5134C20.6285 17.8335 19.5511 18.8456 18.2211 18.9612L16.7109 19.0924C13.5763 19.3649 10.4239 19.3649 7.28924 19.0924L5.77901 18.9612C4.44907 18.8456 3.37166 17.8335 3.17314 16.5134C2.79659 14.0093 2.73518 11.4698 2.98891 8.95421Z",
    fill: "#FFD646"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7a0733164cd722f293c48df172ac995a.svg";
export { ForwardRef as ReactComponent };